const urlPattern = /[-a-zA-Z0-9@:%_.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_.~#?&//=]*)?/gi
const httpPattern = /https?:\/\//
const lineBreakPattern = /(?:\r\n|\r|\n)/g

export default {
  isEven (pageNumber) {
    return pageNumber % 2 === 0
  },
  isUrl (url) {
    return url.match(urlPattern)
  },
  hasHttp (url) {
    return url.match(httpPattern)
  },
  closestNumber (number, arr) {
    if (arr.indexOf(number) > -1) {
      return number
    }

    var indexArr = arr.map(n => Math.abs(n - number))
    var min = Math.min.apply(Math, indexArr)
    return arr[indexArr.indexOf(min)]
  },
  replaceLineBreaks (input) {
    return input.replace(lineBreakPattern, '<br>')
  }
}



// WEBPACK FOOTER //
// ./src/utils/book.js